var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { getNews as getNewsAction } from '../../../actions/creators/news';
var News = /** @class */ (function (_super) {
    __extends(News, _super);
    function News() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    News.prototype.componentDidMount = function () {
        this.props.getNewsAction(this.props.languageId);
    };
    News.prototype.render = function () {
        var news = this.props.news;
        var newsList = news.news;
        return (_jsx("div", __assign({ className: 'items' }, { children: newsList.map(function (newsItem) {
                return _jsx(Link, __assign({ to: "/news/".concat(newsItem.id), className: 'item' }, { children: _jsx("div", __assign({ className: 'head' }, { children: _jsx("div", __assign({ className: 'title' }, { children: newsItem.title })) })) }), newsItem.id);
            }) })));
    };
    return News;
}(React.Component));
News.propTypes = {
    languageId: PropTypes.number.isRequired,
    getNewsAction: PropTypes.func.isRequired,
    news: PropTypes.object.isRequired
};
var mapToState = function (state) { return ({
    languageId: state.application.get('languageId'),
    news: state.application.get('news'),
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getNewsAction: getNewsAction
}, dispatch); };
export default connect(mapToState, mapDispatchToProps)(News);



// WEBPACK FOOTER //
// ./src/components/info/news/index.js